import { DataBean } from "../DataBean";

export class AdquisitionBudgetDocuments extends DataBean {



    public async getBudgetDocuments(idProject: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBudgetDocuments_Number", [idProject]);
    }

}